<div class="mb-4 mb-lg-5">
  <h1 class="mb-1" [innerHTML]="'termsOfUse.title' | translate | safeHtml" data-test="termsOfUse-header-topPageTitle"></h1>
  <p>{{ 'termsOfUse.subTitle' | translate }}</p>
</div>
